import $ from 'jquery';
import Ps from 'perfect-scrollbar';
import debounce from './utils/debounce';

class Header {
    constructor(mobileBreakpoint) {
        this.$document = $(document);
        this.$window = $(window);
        this.speed = 200;
        this.mobileBreakpoint = mobileBreakpoint;

        // Search
        this.$searchForm = $('.js-search-form');
        this.$searchField = $('.js-search-field');
        this.$searchOpenButton = $('.js-search-open');
        this.$searchCloseButton = $('.js-search-close');
        this.$menuContent = $('.js-menu-content');

        // Mobile Menu
        this.$chevrons = $('.js-menu-chevron');
        this.$chevrons.attr('aria-expanded', 'false');

        this.$menuButton = $('.js-menu-button');
        // -------

        // Mobile Menu Events
        this.$chevrons.on('click', $.proxy(this.toggleSubMenu, this));

        // Resize Events
        this.$window.on('resize', debounce(() => {
            if (this.$window.width() > this.mobileBreakpoint) {
                this.resetEverything();
                this.destroyScrollbars();
            } else {
                this.addScrollbars();
            }
        }, 300)).on('load', () => {
            if (this.$window.width() <= this.mobileBreakpoint) {
                this.addScrollbars();
            }
        });

        // Search Events
        this.$searchOpenButton.on('click', $.proxy(this.openSearch, this));
        this.$searchCloseButton.on('click', $.proxy(this.closeSearch, this));

        this.$document.keyup((e) => {
            // Escape Key
            if (e.keyCode === 27) {
                this.closeSearch();
            }
        });

        // Burger Events
        this.$menuButton.on('click', $.proxy(this.menuToggle, this));
        this.$window.on('resize', debounce(() => {
            if (this.$window.width() > this.mobileBreakpoint) {
                this.resetEverything();
                this.destroyScrollbars();
            } else {
                this.addScrollbars();
            }
        }, 300)).on('load', () => {
            if (this.$window.width() <= this.mobileBreakpoint) {
                this.addScrollbars();
            }
        });

        // Scrollbars
        //----------------------------------------
        this.scrollbars = [];
    }

    addScrollbars() {
        this.scrollbars.push(new Ps(this.$menuContent[0]));
    }

    destroyScrollbars() {
        this.scrollbars.forEach((ps) => ps.destroy());
    }

    updateScrollbars() {
        this.scrollbars.forEach((ps) => ps.update());
    }

    closeSearch(e) {
        if (typeof e !== 'undefined') {
            e.preventDefault();
        }

        this.$searchForm.fadeOut(this.speed);
    }

    openSearch() {
        this.$searchForm.fadeIn(this.speed, () => {
            this.$searchField.focus();
        });
    }

    menuToggle() {
        this.$menuButton.toggleClass('is-open');
        this.$menuContent.slideToggle(this.speed, () => {
            this.updateScrollbars();
        });

        $('body').toggleClass('is-scroll-locked');
    }

    resetEverything() {
        // Reset Burger Menu
        this.$menuButton.removeClass('is-open');
        this.$menuContent.removeAttr('style');
        this.$searchForm.removeAttr('style');

        $('body').removeClass('is-scroll-locked');
    }

    // Sub Menu (mobile)
    toggleSubMenu(e) {
        const $elem = $(e.currentTarget);

        $elem.toggleClass('is-open');
        $elem.prev('.c-main-menu__link').toggleClass('is-open');
        $elem.parent().next().slideToggle(this.speed, () => {
            this.updateScrollbars();
        });

        if ($elem.hasClass('is-open')) {
            $elem.attr('aria-expanded', 'true');
        } else {
            $elem.attr('aria-expanded', 'false');
        }
    }
}

export default Header;
